import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { LineupStyle } from '@sorare/core/src/components/lobby/ContenderLayout/types';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage';

export const usePreferredLineupStyle = (): [
  LineupStyle,
  (value: LineupStyle) => void,
] => {
  const { sport } = useSportContext();

  const [lineupStyle, setLineupStyle] = useLocalStorage('sportLineupStyle', {
    [Sport.FOOTBALL]: 'spread',
    [Sport.NBA]: 'spread',
    [Sport.BASEBALL]: 'spread',
  });

  const setSportLineupStyle = (style: LineupStyle) => {
    setLineupStyle({ ...lineupStyle, [sport]: style });
  };

  return [lineupStyle[sport], setSportLineupStyle];
};
